module.exports = __webpack_public_path__ + "static/img/no_video.51f7ddc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/no_video.png
// module id = PInm
// module chunks = 1